<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 11120 11748"
 xmlns:xlink="http://www.w3.org/1999/xlink">
 <g id="Pracovní_x0020_plocha">
  <path class="fil0" d="M10998 3955l-5121 -3878c-134,-101 -312,-103 -448,-3l-5263 3879c-97,71 -166,184 -166,305l0 7142c0,210 201,348 410,348l10387 0c209,0 323,-138 323,-348l0 -7142c0,-119 -27,-231 -122,-303zm-632 7039l0 0 -9612 0 0 -6544 4862 -3596 4750 3594 0 6546z"/>
 </g>
</svg>
</template>

<script>
export default {
  name: 'Home',
};
</script>

<style scoped>
  .fil0 {fill:#666666;fill-rule:nonzero}
</style>
